<p [ngClass]="{'fixed-bottom': isFixed}" class="text-center py-2 foot-note">&copy; All copy right reserved by Merlin</p>
